import React from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import MainMenuComponent from './MainMenuComponent';

const mainMenu = (props) => {
    // console.log(props);
    let countInbox = '';
    let countOutbox = '';
    let countDraft = '';
    let countImportant = '';

    if(props.msgUnreadCnt) {
        if(props.msgUnreadCnt.inbox_un_read) {
            countInbox = props.msgUnreadCnt.inbox_un_read;
            if(countInbox === 0) {
                countInbox = '';
            }
        }
    }

    if(props.msgUnreadCnt) {
        if(props.msgUnreadCnt.draft) {
            countDraft = props.msgUnreadCnt.draft;
            if(countDraft === 0) {
                countDraft = '';
            }
        }
    }

    /*if(props.emailName === 'inbox'){
        countInbox = props.tableRecords.pagination.totalRecords;   
    }*/

    if(props.emailName === 'outbox'){
        countOutbox = props.tableRecords.pagination.totalRecords;   
    }

    /*if(props.emailName === 'drafts'){
        countDraft = props.tableRecords.pagination.totalRecords;   
    }*/

    if(props.emailName === 'important'){
        countImportant = props.tableRecords.pagination.totalRecords;   
    }
    
    return(
        <Wrp>
            {
                props.isMobileWebView === false ? 
                <ul className="menu-items">            
                    <MainMenuComponent icon="fas fa-inbox" linkPage="inbox" name="Inbox" count={countInbox} activeclass="cursor-pointer" countDisplay={true} {...props}/>
                    <MainMenuComponent icon="fas fa-envelope" linkPage="outbox" name="Outbox" count={countOutbox} activeclass="cursor-pointer" countDisplay={false} {...props}/>
                    <MainMenuComponent icon="fas fa-exclamation-circle" linkPage="important" name="Important" count={countImportant} activeclass="cursor-pointer" countDisplay={false} {...props}/>
                    <MainMenuComponent icon="fas fa-envelope-open" linkPage="drafts" name="Drafts" activeclass="cursor-pointer" count={countDraft} countDisplay={true} {...props}/>
                    {/*<MainMenuComponent icon="fas fa-tags" linkPage="tags" name="Tags" activeclass="cursor-pointer" countDisplay={false} {...props}/>*/}
                    <MainMenuComponent icon="fas fa-trash-alt" linkPage="trash" name="Trash" activeclass="cursor-pointer" countDisplay={false} {...props}/>
                    <MainMenuComponent icon="fas fa-archive" linkPage="archive" name="Archive" activeclass="cursor-pointer" countDisplay={false} {...props}/>
                </ul> 
                :
                <div className="card-list">
                    <MainMenuComponent icon="fas fa-inbox" linkPage="inbox" name="Inbox" count={countInbox} activeclass="cursor-pointer" countDisplay={true} {...props}/>
                    <MainMenuComponent icon="fas fa-envelope" linkPage="outbox" name="Outbox" count={countOutbox} activeclass="cursor-pointer" countDisplay={false} {...props}/>
                    <MainMenuComponent icon="fas fa-exclamation-circle" linkPage="important" name="Important" count={countImportant} activeclass="cursor-pointer" countDisplay={false} {...props}/>
                    <MainMenuComponent icon="fas fa-envelope-open" linkPage="drafts" name="Drafts" activeclass="cursor-pointer" count={countDraft} countDisplay={true} {...props}/>
                    {/*<MainMenuComponent icon="fas fa-tags" linkPage="tags" name="Tags" activeclass="cursor-pointer" countDisplay={false} {...props}/>*/}
                    <MainMenuComponent icon="fas fa-trash-alt" linkPage="trash" name="Trash" activeclass="cursor-pointer" countDisplay={false} {...props}/>
                    <MainMenuComponent icon="fas fa-archive" linkPage="archive" name="Archive" activeclass="cursor-pointer" countDisplay={false} {...props}/>    
                </div>
            }
            
        </Wrp>
    )
}

export default mainMenu;